import React, { useState, useContext } from "react";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import {
  Nav,
  NavItem,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Navbar
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { AppContext } from "components/AppContext";
import PropTypes from "prop-types";
import DataExtractLogoSmall from "components/Images/DataExtractLogo_small";
import links from "data/nav.json";

import "styles/App.scss";
import Badge from "shared/badge";
import DataExtractLogo from "components/Images/DataExtractLogo";
import { faQuestionCircle } from "@fortawesome/free-regular-svg-icons";

const AppWrapper = props => {
  const { children } = props;
  // eslint-disable-next-line no-unused-vars
  const { user, signOut, smallNav, setSmallNav, accountsLength } = useContext(
    AppContext
  );
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const [accountMenuOpen, setAccountMenuOpen] = useState(false);
  const pathName = ["/app", "/app/"];
  const history = useHistory();

  const selectedAccountDetails = JSON.parse(
    localStorage.getItem("accountDeatils")
  );

  return (
    <div
      className="app"
      style={
        pathName.includes(pathname)
          ? undefined
          : smallNav
          ? { paddingLeft: "64px" }
          : { paddingLeft: "270px" }
      }
    >
      <header className="app__header">
        <nav
          className="app__nav app__nav--top"
          style={
            pathName.includes(pathname)
              ? { paddingLeft: "270px" }
              : smallNav
              ? { marginLeft: "64px" }
              : { marginLeft: "270px" }
          }
        >
          <a className="skip-to-content-link" href="#main" tabIndex="0">
            Skip to content
          </a>

          <div className="app__nav--topRight">
            {!pathName.includes(pathname) && (
              <div className="changeAccountdropdown">
                <ButtonDropdown
                  size="sm"
                  isOpen={accountMenuOpen}
                  toggle={() => setAccountMenuOpen(!accountMenuOpen)}
                >
                  <DropdownToggle color="link">
                    <div style={{ marginRight: "16px" }}>
                      {selectedAccountDetails?.name}
                    </div>
                  </DropdownToggle>
                  {accountsLength && accountsLength > 1 && (
                    <DropdownMenu right>
                      <DropdownItem
                        color="link"
                        size="sm"
                        onClick={() => {
                          history.push("/app");
                          window.localStorage.setItem("REPORT_FILTERS", null);
                        }}
                        className="d-none d-lg-block"
                      >
                        Change Account
                      </DropdownItem>
                    </DropdownMenu>
                  )}
                </ButtonDropdown>
              </div>
            )}
            <NavLink
              exact
              to={{
                pathname:
                  window.envConfig?.react_app_helpjuice_endpoint ||
                  process.env?.REACT_APP_HELP_JUICE_URL
              }}
              target="_blank"
              style={{ textDecoration: "none" }}
            >
              <FontAwesomeIcon
                icon={faQuestionCircle}
                style={{ marginRight: 6 }}
              />
              Help
            </NavLink>
            <div className="userdropdown">
              <ButtonDropdown
                size="sm"
                isOpen={userMenuOpen}
                toggle={() => setUserMenuOpen(!userMenuOpen)}
              >
                <DropdownToggle color="link">
                  <FontAwesomeIcon icon={faUserCircle} size="lg" />
                  <div style={{ marginRight: "16px" }}>{user?.name}</div>
                  <FontAwesomeIcon icon={faCaretDown} color="primary" />
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem
                    color="link"
                    size="sm"
                    onClick={signOut}
                    className="d-none d-lg-block"
                  >
                    Sign Out
                  </DropdownItem>
                </DropdownMenu>
              </ButtonDropdown>
            </div>
          </div>
        </nav>
        {!pathName.includes(pathname) ? (
          <nav
            className="app__nav app__nav--side"
            style={smallNav ? { width: "64px" } : { width: "270px" }}
          >
            <div
              className={
                smallNav ? "app__nav-header smallnav" : "app__nav-header"
              }
            >
              <Link to="/app" style={{ textDecoration: "none" }}>
                {!smallNav && (
                  <>
                    <DataExtractLogoSmall />
                    <h2 style={{ margin: 5 }}>Insights</h2>
                  </>
                )}
              </Link>
              <button
                onClick={() => setSmallNav(!smallNav)}
                className="smallnav__toggler"
                type="button"
                style={!smallNav ? { marginLeft: 25 } : undefined}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 22 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.785714 3.375H21.2143C21.6482 3.375 22 3.03923 22 2.625V0.75C22 0.335766 21.6482 0 21.2143 0H0.785714C0.351754 0 0 0.335766 0 0.75V2.625C0 3.03923 0.351754 3.375 0.785714 3.375ZM0.785714 10.875H21.2143C21.6482 10.875 22 10.5392 22 10.125V8.25C22 7.83577 21.6482 7.5 21.2143 7.5H0.785714C0.351754 7.5 0 7.83577 0 8.25V10.125C0 10.5392 0.351754 10.875 0.785714 10.875ZM0.785714 18.375H21.2143C21.6482 18.375 22 18.0392 22 17.625V15.75C22 15.3358 21.6482 15 21.2143 15H0.785714C0.351754 15 0 15.3358 0 15.75V17.625C0 18.0392 0.351754 18.375 0.785714 18.375Z"
                    fill="black"
                  />
                </svg>
              </button>
            </div>
            <div
              className={smallNav ? "app__nav-body smallnav" : "app__nav-body"}
            >
              <Nav vertical className="app__nav-links">
                {links.map(item => (
                  <NavItem
                    key={item.link}
                    className={smallNav ? "smallnav" : undefined}
                  >
                    {item.externalUrl ? (
                      <hr
                        style={{
                          color: "#FFF",
                          backgroundColor: "#FFF",
                          height: 1
                        }}
                      />
                    ) : (
                      undefined
                    )}
                    <NavLink
                      exact
                      to={
                        !item.externalUrl
                          ? `/app${item.link}/${selectedAccountDetails?.id}`
                          : { pathname: item.link }
                      }
                      className={item.badge && "disabled"}
                      target={item.externalUrl ? "_blank" : undefined}
                    >
                      {item.badge !== "" ? (
                        <div
                          className={
                            smallNav
                              ? "badgeLink badgeLink__smallNav"
                              : "badgeLink"
                          }
                        >
                          <div className="badgeLink__link">
                            <div
                              dangerouslySetInnerHTML={{ __html: item.icon }}
                            />
                            <p>{item.label}</p>
                          </div>
                          <div className="badgeLink__holder">
                            <Badge badgeText={item.badge} />
                          </div>
                        </div>
                      ) : (
                        <>
                          <div
                            dangerouslySetInnerHTML={{ __html: item.icon }}
                          />
                          <p>{item.label}</p>
                        </>
                      )}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>
            </div>
            <div
              className={
                smallNav ? "app__nav-footer smallnav" : "app__nav-footer"
              }
            />
          </nav>
        ) : (
          <Navbar fixed="top" style={{ width: "500px" }}>
            <Link to="/" className="mr-auto navbar-brand">
              <div style={{ display: "flex", flexDirection: "row" }}>
                <DataExtractLogo />
                <h2 style={{ margin: 5 }}>Insights</h2>
              </div>
            </Link>
          </Navbar>
        )}
      </header>

      <main className="app__main" id="main">
        {children}
      </main>
    </div>
  );
};

AppWrapper.propTypes = {
  children: PropTypes.node.isRequired
};

export default AppWrapper;
